import { LightningIcon, PencilSimpleIcon } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

import { Breadcrumb } from 'components/Breadcrumb';
import { PageHeader } from 'components/PageHeader';
import { PageHeading } from 'components/PageHeading';
import { useTranslation } from '../../../../contexts/translation-context';

interface MethodCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  to: string;
}

const MethodCard: React.FC<MethodCardProps> = ({ icon, title, description, to }) => {
  return (
    <Link to={to} className="card p-8 hover:border-brand transition-colors">
      <div className="text-fg-muted mb-4 flex justify-center">{icon}</div>
      <div className="font-medium text-fg-secondary text-center text-lg border-b border-border pb-4">{title}</div>
      <div className="pt-4 text-center whitespace-normal text-fg-muted">{description}</div>
    </Link>
  );
};

export const CustomerPortalChooseOrderMethodPage = () => {
  const { i18n } = useTranslation();

  return (
    <>
      <PageHeader title={i18n('customerPortal.orders.placeAnOrder')} />

      <PageHeading
        leftSide={
          <Breadcrumb
            parentItem={{
              name: i18n('customerPortal.orders.orders'),
              to: '..',
            }}
            currentItem={i18n('customerPortal.orders.placeAnOrder')}
          />
        }
      />

      <div className="px-8 mb-8">
        <h2 className="heading-two mb-2">{i18n('customerPortal.orders.chooseMethod')}</h2>
      </div>

      <div className="grid md:grid-cols-2 gap-4 px-8 max-w-3xl">
        <MethodCard
          to="./automatic"
          title={i18n('customerPortal.orders.automatic')}
          icon={<LightningIcon className="w-8 h-8" />}
          description={i18n('customerPortal.orders.automaticDescription')}
        />
        <MethodCard
          to="./manual"
          title={i18n('customerPortal.orders.manual')}
          icon={<PencilSimpleIcon className="w-8 h-8" />}
          description={i18n('customerPortal.orders.manualDescription')}
        />
      </div>
    </>
  );
};
